var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.123 5.00098H17.4979V9.916C17.4979 12.0297 15.7945 13.7488 13.7003 13.7488H4.99548V15.6241C4.99548 16.6595 5.83549 17.4995 6.87085 17.4995H16.0289L18.9826 19.8633C19.0959 19.9531 19.2365 20 19.3733 20C19.4632 20 19.5569 19.9805 19.6429 19.9375C19.8578 19.832 19.9984 19.6132 19.9984 19.3749V6.87634C19.9984 5.84098 19.1584 5.00098 18.123 5.00098Z",
    fill: "#8A92A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7472 0H2.49501C1.11583 0 -0.00547791 1.12131 -0.00547791 2.50049V15.0029C-0.00547791 15.2452 0.135175 15.464 0.353967 15.5694C0.436015 15.6085 0.529783 15.628 0.619644 15.628C0.764204 15.628 0.904856 15.5812 1.01816 15.4835L4.59698 12.5024H13.7472C15.1264 12.5024 16.2477 11.3811 16.2477 10.002V2.50049C16.2477 1.12131 15.1264 0 13.7472 0Z",
    fill: "#8A92A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8718 3.75073H4.37038C4.02656 3.75073 3.74525 4.03204 3.74525 4.37585C3.74525 4.71967 4.02656 5.00098 4.37038 5.00098H11.8718C12.2157 5.00098 12.497 4.71967 12.497 4.37585C12.497 4.03204 12.2157 3.75073 11.8718 3.75073Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.37135 6.25122H4.37038C4.02656 6.25122 3.74525 6.53253 3.74525 6.87634C3.74525 7.22016 4.02656 7.50146 4.37038 7.50146H9.37135C9.71517 7.50146 9.99648 7.22016 9.99648 6.87634C9.99648 6.53253 9.71517 6.25122 9.37135 6.25122Z",
    fill: "#FAFAFA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.23de6680c20c7d46802c8541866f4ffd.svg";
export { ForwardRef as ReactComponent };